














































































































import BaseComponent from '@/components/base-component.vue';
import RulesEngineRuleConditions from '@/components/rules-engine/rule/rule-conditions.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiReferencesTypesHierarchy from '@/components/UI/references-types-hierarchy/index.vue';
import { CondicaoParmDTO, RestricaoParmDTO } from '@/interfaces/rules-engine';
import RuleOverrideModel from '@/models/rule-override-model';
import * as service from '@/services/rules-engine';
import * as sieveService from '@/services/sieves';
import { combineLatest, Observable, of, zip } from 'rxjs';
import { map } from 'rxjs/operators';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import RuleViewHistTabs from '../rule-view-hist-tabs.vue';

@Component({
  components: {
    UiReferencesTypesHierarchy,
    RulesEngineRuleConditions,
    PermissionAuth,
    RuleViewHistTabs
  },
})
export default class RulesEngineRuleOverrideForm extends BaseComponent {
  @Prop()
  public isEdit: boolean = false;
  
  @Prop()
  public editItem: any = null;

  public $refs!: {
    form: HTMLFormElement;
  };

  public form: any = {
    valid: false,
    rules: {
      description: [(v) => !!v || 'Digite uma descrição'],
      action: [(v) => !!v || 'Selecione uma ação'],
      ativo: [(v) => v != null || 'Selecione um status'],
      message: [(v) => !!v || 'Digite uma mensagem'],
      palavraCiente: [(v) => !!v || 'Informe a palavra chave'],
      references: {
        clientUnit: [(v) => !!v || 'Selecione uma Unidade'],
        team: [(v) => !!v || 'Selecione um Time'],
        patient: [(v) => !!v || 'Selecione um Paciente'],
        doctor: [(v) => !!v || 'Selecione um Médico'],
      },
    },
  };

  public item: RuleOverrideModel = new RuleOverrideModel();

  public entities: any = [];
  public operators: any = [];
  loading = false;

  @Watch('editItem')
  public onEditItemChanges(val: any) {
    this.item = new RuleOverrideModel();

    this.$refs.form.resetValidation();

    if (!val) {
      return;
    }

    this.item = new RuleOverrideModel(this.editItem);
    this.item.condicoes = [];

    this.loading = true;

    this.listResources().subscribe(([entities, operators, properties]) => {
      this.item.formatConditions(
        this.editItem.condicoes,
        entities,
        operators,
        properties,
      );
      this.loading = false;
    });
  }

  public beforeMount(): void {
    this.listResources().subscribe(([entities, operators]) => {
      this.entities = entities;
      this.operators = operators;
    });
  }

  public listResources(): Observable<any> {
    return zip(
      service.configurableEntity(),
      service.operators(),
      sieveService.getSieves(),
    );
  }

  public onPreSaveClick(): void {
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }

    this.dialog.show(
      'alert',
      (!!this.item.id ? 'Alteração' : 'Inclusão') + ' da Regra de Negócio',
      null,
      'Salvar',
      (check, justif) => {
        this.onSaveClick(justif);
      },
      'Voltar',
      () => {

      },
      null,
      '500px',
      null,
      null,
      null,
      true,
      'Justificativa',
      'Informe o motivo da ' + (!!this.item.id ? 'alteração' : 'inclusão')
    )
  }

  public onSaveClick(justif:string = null): void {
    this.$refs.form.validate();
    if (!this.form.valid || !this.item.validate()) {
      return;
    }

    this.loader.start('Salvando Regra...');
    this.saveConditions(this.item.condicoes).subscribe((conditions) => {
      let item = this.item;

      let payload = new RestricaoParmDTO();
      payload.id = item.id ? Number(item.id) : null;
      payload.codigo = item.codigo;
      payload.descricao = item.descricao;
      payload.acao = item.acao;
      payload.mensagem = item.mensagem;
      payload.textoExplicativo = item.textoExplicativo;
      payload.solicitarCiente = item.solicitarCiente;
      payload.palavraChaveCiente = item.palavraChaveCiente;
      payload.hierarquia = item.hierarquia;
      payload.referenciaHierarquia = item.referenciaHierarquia;
      payload.idSobrescreve = item.sobrescreve.id;
      payload.idUnidade = item.unidade.id;
      payload.ativo = item.ativo;
      payload.motivoAlteracao = justif;
      payload.condicoes = conditions.map(c => {
        let dto = new CondicaoParmDTO();
        dto.campo = c.campo;
        dto.entidade = c.entidade;
        dto.idPropriedade = c.idPropriedade;
        dto.operador = c.operador;
        return dto;
      });

      let obs = !payload.id ? service.saveRule(payload) : service.updateRule(payload);
      obs.subscribe((data) => {
          this.$emit('save');
          this.$refs.form.resetValidation();
          this.item.condicoes = [];
          this.loader.stop();
        }, (error) => {
          this.loader.stop();
          this.showToastApiError(error);
        });
    });
  }

  public onCloseClick(): void {
    const closeAction = () => {
      setTimeout(() => {
        this.$refs.form.resetValidation();
        this.item.condicoes = [];
      }, 100);
      this.$emit('close');
    };

    this.dialog.show(
      'error',
      'Sair sem salvar',
      'Deseja sair sem salvar as alterações?',
      'Cancelar',
      '',
      'Sair',
      closeAction,
    );
  }

  private saveConditions(conditions: any[]): Observable<any[]> {
    const combines = [];

    for (const [index, condicao] of conditions.entries()) {
      if (condicao.isNew) {
        const crivoPayload = {
          descricao: condicao.descricao,
          label: `${condicao.descricao} ( ${condicao.valor} )`,
          tipo: condicao.campo.tipo,
          valor: condicao.valor,
        };

        combines.push(
          sieveService.saveSieve(crivoPayload).pipe(
            map((data) => {
              const savedCrivo = data;
              condicao.crivo = { id: savedCrivo.id };
              return {
                ...condicao,
                sequencial: index,
              };
            }),
          ),
        );
      } else {
        combines.push(
          of({
            ...condicao,
            sequencial: index,
          }),
        );
      }
    }

    return combineLatest(combines).pipe(
      map((data) => {
        return data.map((condition: any) => {
          return {
            campo: condition.campo.nome,
            entidade: condition.entidade.classe,
            idPropriedade: condition.crivo.id,
            operador: condition.operador.operator,
            sequencial: condition.sequencial,
          };
        });
      }),
    );
  }
}
